module.exports = __webpack_public_path__ + "media/images/country_flags/dk-c2de8c326912e540fd75e029b3d5287b.png";